var Reverb = window.Reverb || {};
Reverb.AjaxPaginationHandler = (function () {
  function bindRemotePagination() {
    $(document).on('click', '.remote-pagination-container .pagination a', function (e) {
      e.preventDefault();

      var containerSelector = '.remote-pagination-container';
      var $container = $(containerSelector);
      var updatingContainerClass = $container.data('updating-container-class');
      var url = $(this).prop('href');

      if (updatingContainerClass) {
        $container.spin();
        $container.addClass(updatingContainerClass);
      }

      $('html, body').animate({ scrollTop: 0 }, 400);

      Reverb.APIRequest.get(url).done(function (html) {
        $container.replaceWith(html);

        $container = $(containerSelector); // we find the container again because it's been replaced
        if ($container.data('replace-state') !== undefined) {
          history.replaceState({}, document.title, url);
        }

        $container.trigger('reverb.ajax_load.complete');
      });
    });
  }

  function init() {
    bindRemotePagination();
  }

  return {
    init: init
  };
})();

$(Reverb.AjaxPaginationHandler.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/ajax_pagination.js